import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Root } from './routes';

import './styles/init.css';
import './styles/fonts/Bodoni.scss';
import './styles/fonts/Avenir.scss';

const rootEl = document.getElementById('root');
if (rootEl) {
  const root = ReactDOM.createRoot(rootEl);
  root.render(
    <BrowserRouter>
      <Root />
    </BrowserRouter>,
  );
}
